import type {BadgeDetailsContentModel, DynamicPageContentModel, GlobalButtonsModel} from '@/types/aem';

import {getContent} from './content';

export const getDynamicPages = (): DynamicPageContentModel[] => getContent().dynamicPagesContent?.dynamicPages ?? [];

export const getGlobalButtons = (): GlobalButtonsModel => getContent().globalButtons ?? {};

export const getBadgeDetailsContent = (): BadgeDetailsContentModel => getContent().badgeDetailsContent ?? {};
